import React, { Component } from 'react'

import IconCloseThin from 'components/Icons/CloseThin'
import cn from 'classnames'
import s from './Toasts.scss'
import sLay from 'styles/modules/layout.scss'

const hideTimeoutDuration = 5000

export default class Toast extends Component {
  hideTimeout = null
  mouseEnter = () => {
    clearTimeout(this.hideTimeout)
  }
  mouseLeave = () => {
    this.startHideTimeout()
  }
  startHideTimeout = () => {
    this.hideTimeout = setTimeout(this.closeToast, hideTimeoutDuration)
  }
  closeToast = () => {
    const { hide, toast } = this.props
    hide({ id: toast.id })
  }
  componentDidMount() {
    this.startHideTimeout()
  }
  render() {
    const { toast } = this.props

    return (
      <div
        className={cn(s.toast, sLay['layout-row'], { [s.error]: toast.type === 'error' })}
        onMouseEnter={this.mouseEnter}
        onMouseLeave={this.mouseLeave}
      >
        <div
          className={cn(
            s.toastInner,
            sLay.flex,
            sLay['layout-row'],
            sLay['layout-align-start-center']
          )}
        >
          {toast.title}
          <div className={sLay.flex} />
          <a className={s.close} onClick={this.closeToast}>
            <IconCloseThin size={20} />
          </a>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Toasts/Toast.jsx